import { Stack } from '@kiwicom/orbit-components';
import { ChevronDown } from '@kiwicom/orbit-components/icons';
import { FormattedMessage } from 'react-intl';

import Button from './Button';

type Props = {
  readonly onClick: () => void;
  readonly dataTest?: string;
  readonly isLoading?: boolean;
};

const ShowAllButton = (props: Props): JSX.Element => {
  return (
    <Stack justify="center" align="center">
      <Button
        dataTest={props.dataTest}
        type="secondary"
        size="small"
        onClick={props.onClick}
        iconRight={<ChevronDown />}
        loading={props.isLoading}
      >
        <FormattedMessage
          id="account_v2.homepage.future_trips.show_all"
          defaultMessage="Show all"
        />
      </Button>
    </Stack>
  );
};

export default ShowAllButton;
